import { render, staticRenderFns } from "./ResultUsedMaterials.vue?vue&type=template&id=20c30187&scoped=true&"
import script from "./ResultUsedMaterials.vue?vue&type=script&lang=js&"
export * from "./ResultUsedMaterials.vue?vue&type=script&lang=js&"
import style0 from "./ResultUsedMaterials.vue?vue&type=style&index=0&id=20c30187&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c30187",
  null
  
)

export default component.exports